import { render } from "./IconPointDefaultPath.vue?vue&type=template&id=b430e158&ts=true"
import script from "./IconPointDefaultPath.vue?vue&type=script&lang=ts"
export * from "./IconPointDefaultPath.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__